export const isLastCharacterWhitespaceOrEmpty = (text?: string): boolean => {
    return !text || text.charAt(text.length - 1) === ' ';
};
